import React, { useState } from "react";
import { useTranslation } from 'react-i18next'
import TopMenu from "../../components/TopMenu/TopMenu";
import BottomNav from "../../components/BottomNav/BottomNav";
import Table, { TableColumn } from "../../components/Table/Table";
import usePlaces from "./usePlaces";
import "./Places.css";

type PlaceRow = {
  id: string;
  nome: string;
};

export default function Places() {
  const { places } = usePlaces();
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");

  const normalize = (s: string) =>
    s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

  const filteredPlaces = searchTerm.trim().length === 0
    ? places
    : places.filter((place) =>
        normalize(place.nome).includes(normalize(searchTerm))
      );
  const columns: TableColumn<PlaceRow>[] = [
    {
      id: "nome",
      header: t("pages.cidades.listaCidades"),
      render: (place) => place.nome
    }
  ];

  return (
    <div className="places-page">
      <TopMenu />

      <main className="places-content">
        <section className="places-hero">
          <p className="places-hero-title">{t("pages.cidades.title")}</p>
          <p className="places-hero-subtitle">
            {t("pages.cidades.subtitle")}
          </p>
        </section>

        <div className="places-search-wrapper">
          <div className="places-search-input-wrapper">
            <input
              type="text"
              className="places-search-input"
              placeholder="Buscar local..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button
                type="button"
                className="places-search-clear"
                aria-label="Limpar busca"
                onClick={() => setSearchTerm("")}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
            )}
          </div>
        </div>

        <Table<PlaceRow>
          bodyRowClassName="places-row"
          columns={columns}
          data={filteredPlaces}
          getRowKey={(place) => place.id}
          gridTemplateColumns="1fr"
          headerRowClassName="places-row places-header"
          linkRowClassName="places-link"
          rowHref={(place) =>
            `/plantoes?tipo=presencial&cidadeId=${place.id}`
          }
          wrapperClassName="places-table-wrapper"
        />
      </main>

      <BottomNav />
    </div>
  );
}

